import { render, staticRenderFns } from "./OwnerDetailPage.vue?vue&type=template&id=7d45975b&"
import script from "./OwnerDetailPage.vue?vue&type=script&lang=ts&"
export * from "./OwnerDetailPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports